let fieldsAreInitialized = false;

function changeFileUpload() {
  const multiFileUploads = document.querySelectorAll(
    '.gform_fileupload_multifile'
  );
  if (0 < multiFileUploads.length) {
    multiFileUploads.forEach(function (fileUpload) {
      fileUpload.querySelector('.gform_drop_instructions').innerHTML =
        '<i class="icon icon-cloud" aria-hidden="true"></i>' +
        wp.i18n._x(
          'Drag and drop file to upload or',
          'drag and drop instruction',
          'vtx'
        );

      fileUpload.querySelector('.gform_button_select_files').innerHTML =
        '<span>' +
        wp.i18n._x('Select files', 'drag and drop instruction', 'vtx') +
        '</span>';
    });
  }
}

document.addEventListener('gform_post_render', function () {
  fieldsAreInitialized = true;
  changeFileUpload();
});

// ON READY
window.addEventListener('load', function () {
  if (!fieldsAreInitialized) {
    changeFileUpload();
  }
});
